// API Configuration for different environments
const API_CONFIG = {
  // Updated production URL for new Lambda deployment
  BASE_URL: import.meta.env.VITE_API_URL,

  // Development mode detection (will be overridden by Vite in dev)
  IS_DEV: import.meta.env.VITE_IS_DEV_MODE === 'true',

  // Endpoints
  ENDPOINTS: {
    CHAT: '/chat',
  }
};


// Helper function to build full API URLs
export const getApiUrl = (endpoint: string): string => {
  // Check if we're in development (local dev server, dev mode flag, or dev tunnel)
  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('devtunnels.ms');

  const endpointPath = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  // In development, use proxy-handled URLs
  if (isDev) {
    return `/api${endpointPath}`;
  }

  // In production, use full API Gateway URL
  const baseUrl = (API_CONFIG.BASE_URL || '').endsWith('/')
    ? API_CONFIG.BASE_URL.slice(0, -1)
    : (API_CONFIG.BASE_URL || '');

  return `${baseUrl}${endpointPath}`;
};

export default API_CONFIG;
